import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/b2w.svg";

const B2wIcon = () => {
  return <YourSvg />;
};

export default B2wIcon;
